module.exports = __webpack_public_path__ + "img/材料力学5_8.249c5737.jpg";